function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M3.207 12.075c.292-.083.541-.322.558-.625C4.05 6.045 8.524 1.75 14 1.75h4c5.476 0 9.95 4.295 10.235 9.7.017.303.266.542.558.625A2 2 0 0130.25 14v6a2 2 0 01-1.457 1.925c-.292.083-.543.321-.543.625V23c0 2.9-2.35 5.25-5.25 5.25h-4.267a2 2 0 01-1.733 1h-2a2 2 0 01-2-2v-.5a2 2 0 012-2h2a2 2 0 011.732 1H23A2.75 2.75 0 0025.75 23V12A7.75 7.75 0 0018 4.25h-4A7.75 7.75 0 006.25 12v8a2 2 0 01-2 2h-.5a2 2 0 01-2-2v-6a2 2 0 011.457-1.925z"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M10 15.5a1.5 1.5 0 113 0 1.5 1.5 0 01-3 0z",
  fill: "url(#consultation_svg__paint0_linear)"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M15 15.5a1.5 1.5 0 113 0 1.5 1.5 0 01-3 0z",
  fill: "url(#consultation_svg__paint1_linear)"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M20 15.5a1.5 1.5 0 113 0 1.5 1.5 0 01-3 0z",
  fill: "url(#consultation_svg__paint2_linear)"
});

var _ref5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "consultation_svg__paint0_linear",
  x1: 10.563,
  y1: 14,
  x2: 12.903,
  y2: 14.535,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#89A6BE"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.79,
  stopColor: "#68869F"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "consultation_svg__paint1_linear",
  x1: 15.563,
  y1: 14,
  x2: 17.903,
  y2: 14.535,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#89A6BE"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.79,
  stopColor: "#68869F"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "consultation_svg__paint2_linear",
  x1: 20.563,
  y1: 14,
  x2: 22.903,
  y2: 14.535,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#89A6BE"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.79,
  stopColor: "#68869F"
})));

var SvgConsultation = function SvgConsultation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5);
};

export default SvgConsultation;